<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" class="bg-0A1129">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="background-size: cover; margin: auto;">
                                <CRow>
                                    <CCol sm="6">
                                        <CCard class="position-relative overflow-hidden text-white" :style="{
        backgroundImage: `url(${backgroundUrlBanner})`,
        backgroundSize: 'cover',
        borderRadius: '32px',
        height: '650px', // Make sure height is set!
        position: 'relative', // Important for absolute child
        border:'none'
      }" style="border:none">
                                        <div class="p-4" style="z-index: 3;">
                                            <h3 class="mb-4" style="font-size: 32px; font-weight: 600;">
                                                Get the best education directly from the experts
                                            </h3>
                                        </div>
    
                                            <!-- This will now stick to the bottom of the card -->
                                            <div class="d-flex align-items-center text-white" style="
                                                    position: absolute;
                                                    bottom: 20px;
                                                    left: 20px;
                                                    right:20px;
                                                    border-radius: 24px;
                                                    background: rgba(10, 17, 41, 0.8);
                                                    backdrop-filter: blur(1.5px);
                                                    padding: 12px 16px;
                                                    z-index: 4;
                                                    ">
                                                <img src="https://randomuser.me/api/portraits/women/44.jpg" class="rounded-circle" width="32" height="32" alt="avatar" />
                                                <div class="ml-3">
                                                    <div style="font-weight: bold;">Join with 32k+ students!</div>
                                                    <small>Come see the stories of our successful students</small>
                                                </div>
                                            </div>
                                        </CCard>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-30px-500 text-white mt-3">
                                            Create an Account
                                            <CCard class="custom-bg-blue-black mt-3 p-3">
                                                <h3 class="custom-18px-600 text-white">Parent’s Information</h3>
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Parent’s Name</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/user.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Parent's Name" v-model="name" />
                                                </div>
    
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Parent’s Email</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/sms.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Parent's Email" v-model="email" />
                                                </div>
    
    
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Parent’s Phone Number</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/phone.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                      
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Parent's Phone Number" v-model="phone" />
                                                </div>
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Password</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/eye.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="password" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Parent's Password" v-model="password" />
                                                </div>
                                            </CCard>
    
                                            <CCard class="custom-bg-blue-black mt-3 p-3">
                                                <h3 class="custom-18px-600 text-white">Student's Information</h3>
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Name</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/user.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter  Name" v-model="FullName" />
                                                </div>
    
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Grade</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/user.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Grade" />
                                                </div>
    
    
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Gender</h4>
                                                <div>
                                                    <input type="radio" v-model="selectedGender" value="Male"/><label class="custom-16px-400 font-color-1796FD ml-3">Male</label>

                                                    <input type="radio" v-model="selectedGender" value="Female" class="ml-5"/><label class="custom-16px-400 font-color-1796FD ml-3">Female</label>
                                                </div>

                                                <h4 class="custom-18px-400 text-white text-left mt-3">Phone Number</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/phone.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Phone Number" />
    
                                                </div>
                                                <div>
                                                    <input type="radio" /><label class="custom-16px-400 font-color-1796FD ml-3">Use Parent's Phone Number</label>
                                                </div>
    
    
                                                <h4 class="custom-18px-400 text-white text-left mt-3">Email</h4>
                                                <div style="position: relative; display: inline-block; width: 100%;">
                                                    <img src="../assets/img/flyhigh/sms.png" alt="User Icon" style="
                                                        position: absolute;
                                                        left: 12px;
                                                        top: 50%;
                                                        transform: translateY(-50%);
                                                        width: 20px;
                                                        height: 20px;
                                                        pointer-events: none;
                                                        " />
                                                    <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Email" />
    
                                                </div>
                                                <div>
                                                    <input type="radio" /><label class="custom-16px-400 font-color-1796FD ml-3">Use Parent's Email</label>
                                                </div>
    
                                                <CButton type="button" class="bg-1796FD border-16px p-3 text-white mt-4" block @click="InsertSignUp">{{ lblProgress }}</CButton>
                                                <h3 class="custom-16px-400 text-white text-center mt-3">Have an account<label class="font-color-1796FD ml-3" @click="GoToSignIn()">? Sign In </label></h3>
    
                                            </CCard>
                                        </h3>
                                    </CCol>
                                </CRow>
    
                            </CCol>
    
    
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all" style="z-index: 1;">
            <div class="popup-all1 bg-0A1129" style="z-index: 1;">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:200px" src="../assets/img/flyhigh/success.png" />
                    <h3 class="custom-32px-500">Registration Successful!</h3>
                    <h3 class="custom-18px text-center text-white">Welcome to the platform. </h3>
                </div>
                <CButton class="bg-1796FD border-16px text-white mt-4" @click="closePopup" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrlBanner from "../assets/img/light2.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrlBanner,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: this.$route.query.email,
            phone: "",
            password: "",
            selectedUser: this.$route.query.type === 'individual' ? 'individual' : 'company',
            website: "",
            detail: "",
            has_number: false,
            has_lowercase: false,
            has_uppercase: false,
            has_special: false,

            userOptions: [{

                id: 1,
                UserType: "Candidate",


            }, ],
            isLanguagePopupVisible1: false,

            userEmail: "",
            userPassword: "",

            ErrorLogin: false,
            Message: "",

            response: "",
            lblGoogle: "Google",
            lblProgress: "Continue",
            MessageError: false,
            Error: "",

            emailError: "",
            disallowedDomains: ['yahoo.com', 'gmail.com', 'hotmail.com'],
            genders: [{
                    id: 1,
                    name: "Male"
                },
                {
                    id: 2,
                    name: "Female"
                }
            ]




        };
    },
    created() {
        AOS.init();
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },


    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        password_check() {
            this.has_number = /\d/.test(this.password);
            this.has_lowercase = /[a-z]/.test(this.password);
            this.has_uppercase = /[A-Z]/.test(this.password);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);

            // Debugging logs
            console.log('Password:', this.password);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        registerAccount() {
            this.Error = false;
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.emailError) {
                this.lblProgress = "Continue";
                this.Error = true;
                this.Message = "Error:Please update your email.Email must be company email";
                return;
            }

            if (this.Name === "" || this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.$route.query.type);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);
                // formData.append("eventCode", this.$route.query.eventCode);
                const eventCode = this.$route.query.eventCode;
                if (eventCode) {
                    formData.append("eventCode", eventCode);
                }

                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                    // this.$router.push("Login");
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Profile");
        },
        async login() {
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    const type = this.$route.query.type;
                    const countryid = this.$route.query.countryid;
                    const phone = this.$route.query.phone;


                    this.getUserEmail(idToken, type, countryid, phone);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async getUserEmail(idToken, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    localStorage.setItem('idToken', idToken);
                    this.SetSession(idToken, this.user, type, countryid, phone);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async SetSession(idToken, email, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                if (response.status === 202) {
                    this.registerAccountGoogle(idToken, email, type, countryid, phone);

                } else if (response.status === 200) {
                    if (response.data.userType === 'company') {
                        this.$router.push("Dashboard");
                    } else {
                        this.$router.push("Profile");
                    }

                    console.error("Failed to fetch user information:", response);
                } else {
                    this.emailuser = response.message;
                    console.log("tets" + this.emailuser);
                    this.isLanguagePopupVisible1 = true;
                    this.registerAccountGoogle(this.emailuser, type, countryid, phone);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        registerAccountGoogle(idToken, email, type, countryid, phone) {

            const formData = new FormData();
            this.buttonLabel = 'Processing';
            formData.append("name", email);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("userType", type);
            formData.append("password", "");
            formData.append("website", this.website);
            formData.append("detail", this.detail);
            formData.append("countryId", countryid);


            this.$API
                .post(this.$Register, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.getUserEmailLogin(idToken)


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async getUserEmailLogin(idToken) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSessionLogin(idToken, this.user);

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async SetSessionLogin(idToken, email) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response); // Log the entire response object to see its structure
                if (response.status === 202) {
                    // Handle status 202
                } else if (response.status === 200) {
                    const userData = response.data; // Extract user data
                    console.log("User Data:", userData); // Log the user data object to see its structure

                    // Extract userType directly from userData
                    const userType = userData.userType;
                    console.log("User Type:", userType); // Log the user type

                    // Handle non-200 status code
                    if (response.data.data.userType === 'individual') {
                        this.$router.push("Profile");
                    } else if (response.data.data.userType === '-') {

                        this.$router.push("Profile");

                    } else {

                        this.$router.push("Dashboard");

                    }
                    console.error("Failed to fetch user information:", response);
                } else {
                    // Handle other status codes
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
            this.$router.push("Login");
        },
        validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format validation

            // Check if the email is valid
            if (!emailRegex.test(this.email)) {
                this.emailError = 'Please enter a valid email address.';
                return;
            }

            // Extract the domain from the email address
            const domain = this.email.split('@')[1];

            // Check if the domain is in the disallowed list
            if (this.disallowedDomains.includes(domain)) {
                this.emailError = 'Email cannot be from Yahoo, Gmail, or Hotmail.';
                return;
            }

            // If domain is not in the disallowed list, assume it's a company email
            if (domain.includes('.')) { // Ensures the domain is a valid "company" domain
                this.emailError = null; // Validation passes
            } else {
                this.emailError = 'Please enter a valid company email address.';
            }
        },
        GoToSignIn() {
            this.$router.push("Login");
        },
        //new
        InsertSignUp() {


            this.buttonLabel = "Processing";

            const formData = new FormData();

            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("password", this.password);

            formData.append("userType", "parent");
            formData.append("phone", this.phone);

            formData.append("countryId", 13);


            return this.$API
                .post(this.$Register, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Message = response.data.Message;
                        this.userId = response.data.UserId;

                        {
                            this.isLanguagePopupVisible1 = true;
                            // this.RegisterStudent(this.userId);

                        }
                    } else {
                        this.Message = response.data.Message;
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";
                        this.Message = response.data.Message;
                        this.ErrorMessage = true;
                    }
                });
        },
        RegisterStudent() {

            const formData = new FormData();

            formData.append("Name", this.FullName);
            formData.append("ParentPhoneNumber", this.phone);
            formData.append("Grade", this.SelectedGrade.gradeName);
            formData.append("ParentName", this.name);
            formData.append("ParentEmail", this.email);

            formData.append("countryId", 13);



            return this.$API
                .post(this.$RegisterManualStudent, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        if (response.data > 0) {
                            this.SuccessMessage = true;


                        } else {
                            this.ErrorMessage = true;
                        }
                    } else if (response.status == 500) {
                        this.ErrorMessageNotComplete = true;
                    } else {
                        this.ErrorMessageNotComplete = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.status);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";
                        this.ErrorMessageNotComplete = true;
                    }
                });
        },
    },



};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>